<nav class="cov-sidebar-navigation">
  <ul class="nav-list">
    @if (!isAsmAgent() || (impersonateActiveSession$ | async)) {
      @for (nav of filteredMainNavigation(); track nav.route) {
        <cov-main-navigation-item
          [useOverlay]="!expanded()"
          [navItem]="nav"
          [itemGroupExpanded]="openNavGroup().includes(nav)"
          [activeFloatingMenuNavItem]="activeFloatingMenuNavItem()"
          (navItemActivated)="setActiveFloatingMenuNavItem(nav)"
          (navItemContainerOpened)="setOpenNaviGroups($event)"
        >
          {{ nav.label }}
        </cov-main-navigation-item>
      }
    }
    @if (isAsmAgent()) {
      @for (nav of assistentServiceModeNavigation; track nav.route) {
        <cov-main-navigation-item
          [useOverlay]="!expanded()"
          [navItem]="nav"
          [itemGroupExpanded]="openNavGroup().includes(nav)"
          [activeFloatingMenuNavItem]="activeFloatingMenuNavItem()"
          (navItemActivated)="setActiveFloatingMenuNavItem(nav)"
          (navItemContainerOpened)="setOpenNaviGroups($event)"
        >
          {{ nav.label }}
        </cov-main-navigation-item>
      }
      @if (impersonateActiveSession$ | async) {
        <cov-asm-impersonate-user-information [expanded]="expanded()">
        </cov-asm-impersonate-user-information>
      }
    }
  </ul>
</nav>
